import BasePage from "pages/base_page"
import initFlashNotices from "pages/content/initFlashNotices"

const columnPageEvents = {
  "click .content-authors .content-authors-toggle": "_toggleColumnSidebar",
  "click .content-translations .content-translations-toggle": "_toggleTranslationSidebar",
}

class ColumnPage extends BasePage {
  get events() {
    return columnPageEvents
  }

  initialize(options) {
    super.initialize(options)

    this._toggleColumnSidebar = this._toggleColumnSidebar.bind(this)
    this._toggleTranslationSidebar = this._toggleTranslationSidebar.bind(this)

    initFlashNotices()
  }

  _toggleColumnSidebar(event) {
    event.preventDefault()
    return this.$el.find(".content-sidebar").toggleClass("open")
  }

  _toggleTranslationSidebar(event) {
    event.preventDefault()
    return this.$el.find(".content-translations").toggleClass("open")
  }
}

export default ColumnPage
